import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyD3hYH931gr7pnxf1YaZU5Z9CbDEKkLrOc",
  authDomain: "remington-finance.firebaseapp.com",
  projectId: "remington-finance",
  storageBucket: "remington-finance.firebasestorage.app",
  messagingSenderId: "561694718472",
  appId: "1:561694718472:web:1491acbf32880bba73afbd",
  measurementId: "G-RY5BX4C30R"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
